import DirectorIndicator from './DirectorIndicator';

export default DirectorIndicator;
